<template>
  <a-modal
    class="company-modal-wrapper"
    width="702px"
    :mask-closable="false"
    :visible="visible"
    title="推广资料"
    @cancel="$emit('onCancel')"
    @ok="$emit('onCancel')"
  >
    <a-table
      :columns="columns"
      :data-source="data"
      size="middle"
      :row-key="record => record.id"
      :pagination="false"
    />
  </a-modal>
</template>
<script>
export default {
  props: ['data', 'visible'],
  data() {
    return {
      columns: [
        {
          title: '编号',
          dataIndex: 'post_id',
        },
        {
          title: '类型',
          dataIndex: 'obj_type_name',
        },
        {
          title: '标题',
          dataIndex: 'name',
        },
      ],
    };
  },
  mounted() {},
  methods: {

  },
};
</script>
<style lang="scss" scoped>

</style>